import { getSecret } from "./get-secret.js";
import sendgrid from "@sendgrid/mail";
import { SQSClient, SendMessageCommand } from "@aws-sdk/client-sqs";
import { getDb } from "../db.js";
import { getAwardSettings } from "../awards/get-award-settings.js";
const sqsClient = new SQSClient({ region: "us-west-2" });
let SENDGRID_API_KEY = "";
export async function sendEmail(sendEmailParams) {
    if (!SENDGRID_API_KEY) {
        ({ SENDGRID_API_KEY } = await getSecret("SENDGRID_API_KEY"));
    }
    sendgrid.setApiKey(SENDGRID_API_KEY);
    const params = {
        to: sendEmailParams.to,
        from: sendEmailParams.from,
        subject: sendEmailParams.subject,
        text: sendEmailParams.text,
        html: sendEmailParams.html,
        dynamicTemplateData: sendEmailParams.dynamicTemplateData ?? {},
    };
    const { sendAt, bcc, templateId, table } = sendEmailParams;
    if (sendAt) {
        params.sent_at = sendAt;
    }
    if (bcc?.length) {
        params.bcc = bcc;
    }
    if (templateId) {
        params.templateId = templateId;
    }
    // unsubscribe link
    let appUrl = params.dynamicTemplateData.awardSettings?.appUrl;
    if (templateId && !appUrl && table) {
        try {
            const awardSettings = await getAwardSettings(table);
            appUrl = awardSettings?.appUrl;
        }
        catch (error) {
            console.error(error);
        }
    }
    if (templateId && appUrl) {
        let base64email = "";
        if (typeof params.to === "string") {
            base64email = Buffer.from(params.to, "utf8").toString("base64");
        }
        else if (params.to.length === 1) {
            base64email = Buffer.from(params.to[0], "utf8").toString("base64");
        }
        else if (params.to.email) {
            base64email = Buffer.from(params.to.email, "utf8").toString("base64");
        }
        if (base64email) {
            params.dynamicTemplateData.unsubscribeLink = `${appUrl}/dashboard/unsubscribe/${base64email}`;
        }
    }
    if (process.env.ENV !== "production") {
        params.to = "boadevtest@gmail.com";
        params.bcc = undefined;
        if (params.dynamicTemplateData.unsubscribeLink) {
            params.dynamicTemplateData.unsubscribeLink = `${appUrl}/dashboard/unsubscribe/${Buffer.from(params.to, "utf8").toString("base64")}`;
        }
    }
    const [response] = await sendgrid.send(params);
    const toEmail = typeof params.to === "string"
        ? params.to
        : params.to.email || params.to[0].email || params.to[0];
    if (typeof toEmail === "string") {
        const { putItem } = getDb();
        const timestamp = new Date().toISOString();
        const { headers, ...rest } = response;
        await putItem({
            TableName: "sendgrid-events",
            Item: {
                PK: toEmail,
                SK: response.headers["x-message-id"],
                GSI1_PK: sendEmailParams.table || "unknown",
                GSI1_SK: `${toEmail}#${timestamp}`,
                GSI2_PK: sendEmailParams.table || "unknown",
                GSI2_SK: timestamp,
                ...rest,
                params,
            },
        });
    }
    return response;
}
export async function sendErrorEmail(error) {
    const { message, stack } = error;
    const params = {
        to: { email: "davidhenrycoleman@gmail.com" },
        from: { email: "no-reply@inboundsystems.com", name: "Inbound Systems" },
        subject: "Error in best-of-awards-api",
        text: `${message}\n\n${stack}`,
    };
    return queueEmail(params);
}
export async function queueEmail(params) {
    const { to, bcc = [], from, subject, text, html, sendAt = "", templateId, dynamicTemplateData = {}, table = "unknown", } = params;
    return sqsClient.send(new SendMessageCommand({
        QueueUrl: process.env.EMAIL_QUEUE_URL,
        MessageBody: JSON.stringify({
            to,
            bcc,
            from,
            subject,
            text,
            html,
            sendAt,
            templateId,
            dynamicTemplateData,
            table,
        }),
    }));
}
//# sourceMappingURL=send-email.js.map